import React, { useState } from 'react';
import { post } from '../utils/api';
import { Form, Button, Container, Alert, Row, Col, Card } from 'react-bootstrap';
import { toast } from 'react-toastify';
import './ContactPage.css';

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false); // ✅ loader state

  const handleChange = (e) => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSubmitted(false);
    setLoading(true); // ✅ start loading

    try {
      await post('/contact', formData, 'Contact Form');
      setSubmitted(true);
      setFormData({ name: '', email: '', message: '' });
      toast.success('✅ Message sent successfully!');
    } catch (err) {
      console.error('❌ Error sending contact message:', err);
      setError('Something went wrong. Please try again.');
      toast.error('❌ Failed to send message.');
    } finally {
      setLoading(false); // ✅ stop loading
    }
  };

  return (
    <div className="contact-page">
      <Container style={{ maxWidth: '800px' }}>
        <Row className="g-4 justify-content-center">
          <Col xs={12} lg={10}>
            <Card className="contact-card">
              <Card.Body className="contact-card__body">
                <div className="mb-3">
                  <div className="contact-eyebrow">
                    Contact us
                  </div>
                  <h3 className="fw-bold mb-0">We're here to help</h3>
                </div>

                {submitted && <Alert variant="success">Your message has been sent. We'll get back to you soon.</Alert>}
                {error && <Alert variant="danger">{error}</Alert>}

                <Form onSubmit={handleSubmit}>
                  <Row className="g-3">
                    <Col xs={12} sm={6}>
                      <Form.Label className="fw-semibold">Your Name</Form.Label>
                      <Form.Control
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        placeholder="Name"
                        required
                      />
                    </Col>
                    <Col xs={12} sm={6}>
                      <Form.Label className="fw-semibold">Your Email</Form.Label>
                      <Form.Control
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        placeholder="Email"
                        required
                      />
                    </Col>
                    <Col xs={12}>
                      <Form.Label className="fw-semibold">Your Message</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={5}
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        placeholder="Tell us how we can help..."
                        required
                      />
                    </Col>
                    <Col xs={12}>
                      <Button variant="primary" type="submit" className="w-100 py-2 fw-semibold" disabled={loading}>
                        {loading ? 'Sending...' : 'Send message'}
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ContactPage;
